import React from "react";
import { Empty } from "antd";
import ReactApexChart from "react-apexcharts";
import { FormatUSD } from "../../utils/helpers/string";

const BarChart = ({ seriesData, categories, title, graphType, dataSymbol }) => {
  const chartData = {
    data: Array.isArray(seriesData) ? seriesData : [],
    categories: Array.isArray(categories) ? categories : [],
  };

  const isNoData =
    !chartData.data ||
    chartData.data.length === 0 ||
    chartData.data.every(
      (series) =>
        !series.data || !Array.isArray(series.data) || series.data.length === 0
    );

  const options = {
    chart: {
      type: "bar",
      height: 350,
      toolbar: { show: false },
      background: "#000",
    },
    grid: {
      show: true,
      borderColor: "#ffffff33",
      strokeDashArray: 4,
      xaxis: { lines: { show: false } },
      yaxis: { lines: { show: true } },
    },
    xaxis: {
      axisBorder: { show: false },
      type: "category",
      categories: chartData.categories,
      labels: { rotate: -90 },
      title: {
        text: title, // You can change this label
        style: { color: "#fff" },
      },
    },
    yaxis: {
      axisBorder: { show: false },
      labels: {
        formatter: function (y, { seriesIndex }) {
          if (isNaN(y) || y === undefined || y === null) return "";
          const value = y.toFixed(0);
          const label = chartData.data?.[seriesIndex]?.label;

          if (label === "amount") {
            return FormatUSD(value);
          } else if (label === "percentage") {
            return value + "%";
          } else if (label === "no_of_trades") {
            return value + " Trades";
          } else if (label === "lots") {
            return value + " Lots";
          } else {
            return value;
          }
        },

        style: { colors: "#fff" },
      },
      title: {
        text: graphType,
        style: { color: "#fff" },
      },
    },
    plotOptions: {
      bar: {
        columnWidth: "30%",
        borderWidth: 2,
        borderColor: "#75EBC3",
      },
    },
    stroke: {
      show: true,
      width: 2,
      colors: ["#75EBC3"],
    },
    fill: {
      type: "gradient",
      gradient: {
        shade: "light",
        type: "vertical",
        shadeIntensity: 0.5,
        opacityFrom: 0.34,
        opacityTo: 0.1,
        stops: [0, 100],
        colorStops: [
          { offset: 0, color: "#75EBC3", opacity: 0.34 },
          { offset: 100, color: "#75EBC3", opacity: 0.1 },
        ],
      },
    },
    annotations: {
      yaxis: [
        {
          y: 0,
          borderColor: "#000",
          borderWidth: 0.6,
          label: {
            borderColor: "#000",
            style: { color: "#fff", background: "#000" },
          },
        },
      ],
    },
    theme: { mode: "dark" },
    legend: { show: false },
    dataLabels: { enabled: false },
  };

  return (
    <div
      className="chart-wrapper"
      style={{ position: "relative", height: "100%" }}
    >
      {isNoData ? (
        <div
          className="no-data-message"
          style={{
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "18px",
            color: "#fff",
          }}
        >
          <Empty
            description={
              <span style={{ color: "#fff" }}>No Data Available</span>
            }
          />
        </div>
      ) : (
        <ReactApexChart
          options={options}
          series={chartData.data}
          type="bar"
          height={270}
        />
      )}
    </div>
  );
};

export default BarChart;
